import React from 'react';

export const ComponentThatThrows = () => {
  throw new Error('this is a deliberate error for testing purposes');

  // eslint-disable-next-line
  return <div>[space intentionally left blank]</div>;
};
